<section class="ui-form-section">
  <header class="ui-form-section__header" *ngIf="title">
    <div class="ui-form-section__title-wrap">
      <mat-icon *ngIf="icon" class="ui-form-section__icon">{{ icon }}</mat-icon>
      <h3 class="ui-form-section__title">{{ title }}</h3>
    </div>
    <div class="ui-form-section__actions" *ngIf="showHeaderActions">
      <ng-content select="[sectionActions]"></ng-content>
    </div>
  </header>
  <div class="ui-form-section__content">
    <ng-content></ng-content>
  </div>
</section>
